/** @jsxImportSource @emotion/react */
import { cn } from '@shared/cove-ui';
import React from 'react';

export interface IAsSeenOnProps {
  className?: string;
  [key: string]: unknown;
}
const AsSeenOn: React.FC<IAsSeenOnProps> = ({ className, ...props }) => {
  return (
    <section
      className={cn(
        'p-cove-25 gap-cove-15 mx-auto flex w-full max-w-[1440px] flex-col items-center justify-center',
        'sm:p-cove-35 sm:gap-cove-35 sm:flex-row',
        className
      )}
      {...props}
    >
      <p
        className={cn(
          'text-cove-navy-blue mb-cove-10 mx-auto mt-0 !font-bold',
          'sm:m-0'
        )}
      >
        As Seen On
      </p>
      <div
        className={cn(
          'gap-cove-15 h-cove-35 grid grid-cols-3 items-center justify-center',
          'sm:gap-cove-35'
        )}
      >
        <img
          src="https://www.datocms-assets.com/10154/1657829769-cbs.png"
          alt="CBS Company Logo"
          width={63}
          height={20}
          className="mx-auto my-0"
        />
        <img
          src="https://www.datocms-assets.com/10154/1683066543-nbc-logo.png"
          alt="NBC Company Logo"
          width={39}
          height={39}
          className="mx-auto my-0"
        />
        <img
          src="https://www.datocms-assets.com/10154/1657829806-fox.png"
          alt="FOX Company Logo"
          width={45}
          height={20}
          className="mx-auto my-0"
        />
      </div>
    </section>
  );
};
export default AsSeenOn;
